import { render, staticRenderFns } from "./manufacture-select-ajax.vue?vue&type=template&id=5922444c&scoped=true&"
import script from "./manufacture-select-ajax.vue?vue&type=script&lang=js&"
export * from "./manufacture-select-ajax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5922444c",
  null
  
)

export default component.exports